import { get, chain, size } from "lodash"
import update from "immutability-helper"
import { createMatch } from "helpers/string"

export default function reducer(state, { action, id, value }) {
  if (action === "reset") { return {} }

  if (!value || (id === "type" && !size(value))) { return update(state, { $unset: [id] }) }

  const replaceFilter = (id, filter) => {
    return update(state, { [id]: { $set: filter } })
  }

  switch (id) {
    case "search":
      return replaceFilter(id, searchFilter(value))
    case "type":
      return replaceFilter(id, typeFilter(value))
    case "favorite":
      return replaceFilter(id, favoriteFilter(value))
  }

  return state
}

function searchFilter(value) {
  return {
    id: "search",
    condition: (row) => {
      const match = createMatch(value)
      const { name, description, ticker } = row
      return (match(name) || match(ticker) || match(description))
    },
    value,
  }
}

function typeFilter(values) {
  return {
    id: "type",
    condition: (row) => chain(values)
      .map("value")
      .includes(get(row, "resourceType"))
      .value(),
    value: values,
  }
}

export function filterFavorite(row) {
  return get(row, "isFavorite")
}

function favoriteFilter(value) {
  return {
    id: "favorite",
    condition: filterFavorite,
    value,
  }
}
